import { state } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { error } from 'jquery';
import Swal from 'sweetalert2';
import {
  FormControl,
  FormGroup,
  FormBuilder,
  Validator,
  Validators,
} from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { LoggerService } from 'src/app/services/logger.service';
import { Store } from '@ngrx/store';
import { selectAdvisorData, selectAdvisorLoading } from 'src/app/state/selectors/advisors.selector';
import { loadAdvisorData } from 'src/app/state/actions/advisors.actions';
import { Observable, startWith, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css'],
})
export class SettingsComponent implements OnInit {
  settingsKeyLabel: any;
  categories: any = new Set();
  categoryList: any = [];
  categoryWiseList: any = [];
  selectedCategory: any = ""
  userDetails: any;
  accessToken = sessionStorage.getItem('accessToken');
  headers = {
    headers: {
      Authorization: 'Bearer ' + this.accessToken,
      'Content-Type': 'application/json',
    },
  };
  // mailConfigSmtp: any;
  mailConfigSmtp: FormGroup = new FormGroup({
    username: new FormControl(''),
    password: new FormControl(''),
  });
  cCmailConfigSmtp: FormGroup = new FormGroup({
    gbSuportMail: new FormControl(''),
    mailRegardsStudent: new FormControl(''),
    systemAdminMail: new FormControl(),
    systemAdminName: new FormControl(''),
    emailRegards: new FormControl(''),

  })
  description: void;
  this: any;
  id: any;
  ccSettingsKeyLabel: any;
  pachToCc: {};
  data: any;
  data1: any = [];
  details: any = [];
  constDetails: any = [];
  advisorList = [];
selectedAdvisors: number[] = [];
disableCloeySelection: 'yes' | 'no' = 'no';
advisorData$: Observable<any>; 
allBrokerList: any[];
advisorNames: any[];
private destroy$ = new Subject<void>();
dtTrigger: Subject<any> = new Subject<any>();
dropdownSettings = {};
form: FormGroup;
selectedAdvisorIds: any = [];
  minDate: Date;
  maxDate: Date;


  constructor(private logger: LoggerService, private http: HttpClient,
    private formBuilder: FormBuilder,
    private ccformBuilder: FormBuilder,
    private fb: FormBuilder,
    private store: Store<{ advisorData: []}>) {
      
        this.advisorData$ = store.select(selectAdvisorData);
       
     }

  ngOnInit(): void {
    setTimeout(()=>{
      sessionStorage.setItem('pageName', 'Settings');
    },100)

    this.getDetails();
    this.mailDetailsForm();
    this.ccmailDetailsForm();
    this.getAdvisorsList();
    this.form = this.fb.group({
      multiSelectAdvisor: [null],
    });
    this.dropdownSettings = {
      singleSelection: false,
      closeDropDownOnSelection: true,
      idField: 'id',
      textField: 'name',
      selectAllText: "Select All",
      unSelectAllText: "Deselect All",
      itemsShowLimit: 3,
      allowSearchFilter: true,
      innerHeight: 400
    };

    const now = new Date();
    this.minDate = new Date(now.getFullYear(), now.getMonth(), 1); // 1st day of current month
    this.maxDate = new Date(now.getFullYear(), now.getMonth() + 1, 0); // Last day of current month
  }
  mailDetailsForm() {
    this.mailConfigSmtp = this.formBuilder.group({
      username: ['', Validators.compose([Validators.required])],
      password: ['', Validators.compose([Validators.required])],
    });
  }
  ccmailDetailsForm() {
    this.cCmailConfigSmtp = this.ccformBuilder.group({
      gbSuportMail: ['', Validators.compose([Validators.required])],
      mailRegardsStudent: ['', Validators.compose([Validators.required])],
      systemAdminMail: ['', Validators.compose([Validators.required])],
      systemAdminName: ['', Validators.compose([Validators.required])],
      emailRegards: ['', Validators.compose([Validators.required])],

    })
  }
  get mailFormGet() {
    return this.mailConfigSmtp.controls;
  }
  get cCmailConfigSmtpGet() {
    return this.cCmailConfigSmtp.controls;
  }
  public getAdvisorsList() {
    this.store.dispatch(loadAdvisorData());
  this.advisorData$ = this.store.select(state => state.advisorData).pipe(
    startWith([]),
    takeUntil(this.destroy$)
  );

  this.advisorData$?.subscribe(data => {
    if (data) {
      console.log('cloey: ', data);

      if ((data?.advisorData == undefined || Object.keys(data.advisorData).length <= 0) && data?.loading == true) {
        console.log('No data to process', new Date().toISOString());
        return;
      }

      if (this.advisorList.length > 0 && data?.loading == false) {
        return;
      }

      const role = sessionStorage.getItem('role');
      this.advisorList = [...data?.advisorData];

      this.advisorList = this.advisorList.map((broker) => {
        return {
          ...broker,
          published: !broker.published || broker.published == undefined || broker.published == null ? 'Inactive' : 'Active'
        }
      });

      setTimeout(() => {
        this.allBrokerList = this.advisorList;

        //Filter out null/undefined names and sort
        this.advisorList = this.advisorList
          .filter((broker: any) => broker.name != null && broker.name != undefined)
          .sort((a, b) => {
            const order = { true: 1, false: 2 };
            if (order[a.status] !== order[b.status]) {
              return order[a.status] - order[b.status];
            }
            return a.name.trim().localeCompare(b.name.trim());
          });

        this.advisorList = this.advisorList
          .filter((broker: any) => broker.brokerType.toUpperCase() === 'ADVISOR')

          this.selectedAdvisors = this.advisorList.filter((broker: any) => broker.enableCloey == true);
          this.selectedAdvisorIds = this.advisorList.filter((broker: any) => broker.enableCloey == true).map((adv:any) => Number(adv.id));
          this.form.get('multiSelectAdvisor')?.setValue(this.selectedAdvisors);

        console.log('Advisor names:', this.advisorList);

        // this.restLoader = false;

        setTimeout(() => {
          this.dtTrigger.next(null);
        }, 0);
      }, 0);
    } else {
      console.error('Observable returned undefined');
    }
  });
  }
  getDetails() {
    let endPoint = '/api/ap/settings';
    this.categories = new Set();
    this.details = []
    this.constDetails = []
    this.http.get(environment.apiUrl + endPoint).subscribe(
      (response: any) => {
        if (response.status == '200') {
          let details = response.data[0];
          this.categoryList = response.data;
          this.data = this.categoryList;
          // response.data.map(res => res.category != null ? this.categories.add(res.category) : '')
          response.data.forEach(res => {
            if (res.category != null) {
              this.categories.add(res.category);
            }
          });
          this.categories = [...this.categories]
          this.categories?.length > 0 ? this.selectedCategory = this.categories[0] : ''

          console.log('this.categoryList', this.categoryList)
          console.log('this.selectedCategory', this.selectedCategory)

          for (let i = 0; i < this.categoryList.length; i++) {
            const obj = {
              id: this.categoryList[i].id || '',
              description: this.categoryList[i].description || '',
              key: this.categoryList[i].settingsKey || '',
              keyLabel: this.categoryList[i].settingsKeyLabel || '',
              category: this.categoryList[i].category || '',
              valueType: 'string',
              display: true,
              value: JSON.parse(this.categoryList[i].settingsValue) || {}
            };
            this.details.push(obj)
            this.constDetails.push(obj)

            if (this.categoryList[i].category == 'MAIL') {
              const values = JSON.parse(this.categoryList[i].settingsValue)

              if (!this.data1[i]) {
                this.data1[i] = [[], []]; // Initialize as an array with two sub-arrays for MAIL and ALT_SERVERS
              }
              if(values?.SERVERS!=undefined){
                Object.entries(values.SERVERS).forEach(([key, value], j) => {
                  if (!this.data1[i][0][j]) {
                    this.data1[i][0][j] = {}; // Initialize it as an object
                  }
                  if (key == values.SELECTED) {
                    this.data1[i][0][j].isActive = true;
                  } else {
                    this.data1[i][0][j].isActive = false;
                  }
                  }
                )
              }
              if(values?.ALT_SERVERS!=undefined){
                Object.entries(values.ALT_SERVERS).forEach(([key, value], j) => {
                  if (!this.data1[i][1][j]) {
                  this.data1[i][1][j] = {}; // Initialize it as an object
                }
                if (key == values.ALT_SELECTED) {
                  this.data1[i][1][j].isActive = true;
                } else {
                  this.data1[i][1][j].isActive = false;
                }
              }
              )
            }
            }
          }
          
          this.logger.log('responce : ', response.data[0]);
          this.logger.log('details : ', this.details);
          this.logger.log('constDetails : ', this.constDetails);
          this.settingsKeyLabel = details.settingsKeyLabel;
          let userDetails = JSON.parse(details.settingsValue);
          this.mailConfigSmtp.patchValue(userDetails);
          this.mailConfigSmtp.markAllAsTouched();
          this.logger.log(userDetails);
          this.description = details.description;
          this.id = details.id;
          let OtherDetails = response.data[1];
          this.ccSettingsKeyLabel = OtherDetails.settingsKeyLabel;
          let ccDetails = JSON.parse(OtherDetails.settingsValue);
          this.logger.log(ccDetails);

          let pachToCc = {
            gbSuportMail: ccDetails.GBSUPPORT,
            mailRegardsStudent: ccDetails.MAIL_REGARDS_STUDENTS,
            systemAdminMail: ccDetails.SYS_ADMIN_EMAIL,
            systemAdminName: ccDetails.SYS_ADMIN_NAME,
            emailRegards: ccDetails.MAIL_REGARDS,
          }
          this.cCmailConfigSmtp.patchValue(pachToCc);

          console.log(this.details)
          console.log(this.categoryList)

        } else {
          Swal.fire({
            title: 'Error', text: response.data.message ||
              response.error.message ||
              response.data.error
          });

        }
      },
      (error) => {
        Swal.fire({ title: 'Error', text: error.message || error.status.message });
      }
    );
  }
  UpdatesmtpMail(i) {
    console.log(this.details[i])

    let data = { ...this.constDetails[i], value: JSON.stringify(this.constDetails[i].value) };
    delete data.id;

    let endPoint = `/api/ap/settings/${this.details[i].id}`
    this.http.put(environment.apiUrl + endPoint, data)
      .subscribe((response: any) => {
        if (response.status == '200') {
          this.logger.log(response.data);
          Swal.fire({ title: 'Success', text: response.message, confirmButtonText: "Ok", allowOutsideClick: false }).then((result) => {

            // window.location.reload()
            this.getDetails();
            this.mailDetailsForm();
            this.ccmailDetailsForm();
          });
        }
      }, (error) => {
        Swal.fire({ title: 'Error', text: error.message || error.status.message });
      })
  }

  getServerValue(i: number, itemKey: string, objectKey: string) {
    return this.details[i]?.value?.SERVERS[itemKey]?.[objectKey] || '';
  }

  handleChangeDetails($event, i, SERVER, item_key, object_key) {
    this.details[i].value[SERVER][item_key][object_key] = $event.target.value;
  }

  setDefaultServer(DEFAULT, selectedKey, index: number) {
    console.log(index, DEFAULT, selectedKey)
    if (DEFAULT == 'SELECTED') {
      this.details[index].value.SELECTED = selectedKey;
    }
    if (DEFAULT == 'ALT_SELECTED') {
      this.details[index].value.ALT_SELECTED = selectedKey;
    }
    this.UpdatesmtpMail(index)
  }

  parsedDataCache: { [key: string]: any } = {};
  getParseData(data) {
    // console.log({data},JSON.parse(data))
    // return data != null && data != undefined && data != '' ? JSON.parse(data) : []
    if (this.parsedDataCache[data]) {
      return this.parsedDataCache[data];
    }

    // Parse and cache the data
    const parsedData = data != null && data !== '' ? JSON.parse(data) : [];
    this.parsedDataCache[data] = parsedData;
    return parsedData;
  }

  getSettingsKey(object, key) {
    // if(object?.[key]!==undefined){
    //   return object[key]
    // }
    // return key
    const obj = { username: "Username", password: "Password", SERVERS: "SMTP Servers", ALT_SERVERS: "SMTP Alternate" }
    if (obj?.[key] !== undefined) {
      return obj[key]
    }
    return key
  }

  toggleAccordion(event: Event, index: number) {
    const element = event.target as HTMLElement;
    element.classList.toggle("active");
    this.data[index].isActive = !this.data[index].isActive;
  }

  toggleAccordion1(event: Event, i: number, j: number, k: number) {
    console.log(i, j, k)
    const element = event.target as HTMLElement;
    element.classList.toggle("active");
    this.data1[i][j][k].isActive = !this.data1[i][j][k].isActive;
  }


  UpdateCloey() {
    let endPoint = `/api/ap/settings/activateCloey`
    // const selectedAdvisorIds = this.selectedAdvisors.map((adv: any) => adv.id);
    const allIds = this.advisorList.map((adv: any) => Number(adv.id));
    const deselectedIds = allIds.filter(id => !this.selectedAdvisorIds.includes(id));
    this.http.patch(environment.apiUrl + endPoint, {advisorIds: this.selectedAdvisorIds, deselectedIds: deselectedIds})
      .subscribe((response: any) => {
        if (response.status == '200') {
          console.log("updated!")
        }
      }, (error) => {
        Swal.fire({ title: 'Error', text: error.message || error.status.message });
      })
  }

  multiSelectAdvisorItemSelect(event: any) {
    // this.multiSelectProviancenames.push(event);
    this.selectedAdvisorIds.push(Number(event.id));
    // this.getprovincelistselection1(this.defaultCountry, this.multiSelectProviance);
  }

  multiSelectAdvisorSelectAll(event: any) {
    this.selectedAdvisorIds = [];
    event.forEach((advisor: any) => {
      this.selectedAdvisorIds.push(Number(advisor.id));
      // this.multiSelectProviancenames.push({ "id": proviance.id, "shortName": proviance.shortName });

    });
    // this.getprovincelistselection1(this.defaultCountry, this.multiSelectProviance);
  }
  multiSelectAdvisorItemDeSelect(event: any) {
    let indexOf = this.selectedAdvisorIds.indexOf(event.id);
    // this.multiSelectProviancenames.splice(indexOf, 1);
    this.selectedAdvisorIds.splice(indexOf, 1);

    // this.getprovincelistselection1(this.defaultCountry, this.multiSelectProviance);

  }
  multiSelectAdvisorItemDeSelectAll(event: any) {
    this.selectedAdvisorIds = [];
    // this.multiSelectProviancenames = [];
    // this.getprovincelistselection1(this.defaultCountry, this.multiSelectProviance);
  }

  numbersOnly(event) {
    const key = event.key || String.fromCharCode(event.keyCode);
    console.log({ key },event.target.value)
    // Check if the key is an alphabetical character (A-Z or a-z) or a space
    if (/(^[0-9 \-]+$)/.test(key)) {
      return true;
    } else {
      return false;
    }
  }
}
